import React from 'react';
import Auth from '../Auth';
import { USER_ROLES } from '../../utilities/constants';

/**
 * @description 協力会社管理者+職長専用トグル
 */
const SubContractorToggle = props => (
  <Auth approvedRoles={[USER_ROLES.partner, USER_ROLES.foreman]}>
    {props.children}
  </Auth>
);

export default SubContractorToggle;



// WEBPACK FOOTER //
// ./src/components/toggle/SubContractorToggle.jsx